import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { MapTooltip } from "../../../widgets/map/mapAddons/mapTooltip";
import { getBasicObjectTypeLayer, getAllRoadObjectsLayer } from "../../../widgets/map/mapFeatures/layers";
import { showMapTooltip } from "../../../widgets/map/mapFeatures/mapFunctions/showMapTooltip/showMapTooltip";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import { useDispatch } from "react-redux";
import { setMapTooltipIsVisible } from "../../../stateManagement/reducers/MapTooltipSlice";
import { getObjectsOnMapPoint } from "../../../widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/getObjectsOnMapPoint";
import { MapOverlayWidget } from "../../../widgets/map/mapAddons/mapOverlayWidget";
import TableUnderMap from "../../tables/tableUnderMap/TableUnderMap";
import { mapLayersDict } from "../mapLayersDict";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";

export function MapRoadAccidents() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const mapName = "RoadAccidents"
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const { wmsServer, wmsVersion, workspace } = getItemWebStorage('currentConfig')
    const mapFilterString = useAppSelector(state => state.roadAccidents.roadAccidentsMapFilterString)
    const tableFilterString = useAppSelector(state => state.roadAccidents.roadAccidentsMapTableFilterString)
    const tableUnderMapIsShown = useAppSelector(state => state.contentHeader.tableUnderMapIsShown)

    const roadsLayer = getAllRoadObjectsLayer()
    const [permanentLayers] = useState([roadsLayer])

    useEffect(() => {
        const { mapLayer, caption } = mapLayersDict[mapName] ?? {}
        caption && setMapTitle(`Карта «${caption}»`)
        if (!mapLayer) {
            navigate('/app/error')
        }
        const layerFilter = mapFilterString
        const objectTypeLayer = getBasicObjectTypeLayer(mapLayer, wmsServer, wmsVersion, workspace, layerFilter)
        setAdditionalLayers([objectTypeLayer])
    }, [mapFilterString]);

    function applyMapTooltip(map: any) {
        const pointerMoveFunc = (event: any) => showMapTooltip(event, mapName, additionalLayers[0], map)
        map?.on("pointermove", pointerMoveFunc)
        return {
            off: () => {
                map?.un("pointermove", pointerMoveFunc)
                dispatch(setMapTooltipIsVisible(false))
            }
        }
    }

    function applyMapObjectsFind(map: any) {
        const clickFunc = (event: any) => getObjectsOnMapPoint(event, mapName, additionalLayers[0])
        map?.on("singleclick", clickFunc)
        return {
            off: () => {
                map?.un("singleclick", clickFunc)
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "mapTooltip",
            func: applyMapTooltip
        },
        {
            name: "objectsFindAlways",
            func: applyMapObjectsFind
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={mapName} type="map" />
            <div className="map-widget-with-toast">
                <MapTooltip type={mapName} />
                <MapWidget additionalLayers={additionalLayers} mapEventHandlers={mapEventHandlers} permanentLayers={permanentLayers} mapSizeClass={tableUnderMapIsShown ? 'half-size-map-widget' : null} />
                <MapOverlayWidget />
                {tableUnderMapIsShown && <TableUnderMap objectType="RoadAccidents" canBeFiltered={false} filtersExpression={tableFilterString} />}
            </div>
        </>
    )
}
